import { Card } from 'components/@common/Card'
import styled from 'styled-components'

export const I = styled.i`
  font-size: 30px;
  vertical-align: 50%;
  text-align: center;
  border-radius: 100%;
  padding: 5px;
  padding-bottom: 10px;
`

export const ErrorIcon = styled(I)`
  color: ${(props) => props.theme.errorIconColour};
`

export const InfoIcon = styled(I)`
  color: ${(props) => props.type === 'info' && props.theme.infoIconColour};
  font-size: 50px;
  margin-top: 10px;
`

export const Container = styled(Card)`
  display: flex;
  align-items: center;
  margin-top: 12px;
  margin-left: 12px;
  margin-right: 12px;
`
